import styled from 'styled-components';
import Link from '../Link';
import { m, p } from '../Spacing/core';
export const StickyContainer = styled.div`
  ${p('md')};
  z-index: ${({
  theme
}) => theme.zIndex.stickyActions};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid ${({
  theme
}) => theme.palette.border};
  background-color: ${({
  theme
}) => theme.palette.backgroundPrimary};
  box-shadow: ${({
  theme
}) => theme.boxShadowMediumUpward};

  &[data-stacked='true'] {
    border-bottom: ${({
  theme
}) => `1px solid ${theme.palette.border}`};
  }
`;
export const SpacerElement = styled.div`
  & + & {
    margin-top: 0 !important;
  }
`;
export const ScreenReaderLink = styled(Link).attrs({
  className: 'sr-focusable'
})`
  display: inline-block;
  ${m('sm')};
`;
//# sourceMappingURL=styles.js.map